// Product Quick Add to Cart with Toast Notification
(function() {
  'use strict';

  let isInitialized = false;
  let isProcessing = false;
  let lastRequestTime = 0;
  const REQUEST_DEBOUNCE_MS = 1000; // Prevent requests within 1 second

  function init() {
    if (isInitialized) return;
    isInitialized = true;

    console.log('[Product Quick Add] Initializing...');

    // Create toast container
    createToastContainer();

    // Use event delegation on body with capture phase
    document.body.addEventListener('click', function(e) {
      const button = e.target.closest('.product-hover-add-to-cart');
      if (!button) return;

      e.preventDefault();
      e.stopPropagation();

      console.log('[Product Quick Add] Button clicked', button);

      handleAddToCart(button);
    }, true); // Use capture phase
  }

  function handleAddToCart(button) {
    if (isProcessing) {
      console.log('[Product Quick Add] Already processing, skipping');
      return;
    }

    const variantCount = parseInt(button.getAttribute('data-variant-count'));
    const productContainer = button.closest('.product-thumb-container');

    if (!productContainer) {
      console.error('[Product Quick Add] Product container not found');
      return;
    }

    // Si el producto tiene más de una variante, mostrar modal
    if (variantCount > 1) {
      console.log('[Product Quick Add] Product has multiple variants, showing modal');
      showVariantModal(button);
      return;
    }

    // Si solo tiene una variante, añadir directamente
    const variantId = button.getAttribute('data-variant-id');
    addToCart(variantId, button, productContainer);
  }

  function showVariantModal(button) {
    const variants = JSON.parse(button.getAttribute('data-variants'));
    const productTitle = button.getAttribute('data-product-title');
    const productUrl = button.getAttribute('data-product-url');
    const productContainer = button.closest('.product-thumb-container');
    const productImage = productContainer.querySelector('img').src;

    console.log('[Product Quick Add] Showing variant modal for:', productTitle, variants);

    // Crear modal
    const modalOverlay = document.createElement('div');
    modalOverlay.className = 'variant-modal-overlay';

    const modal = document.createElement('div');
    modal.className = 'variant-modal';

    // Obtener nombre de la opción (ej: "Size", "Talla", etc.)
    const optionName = variants[0].option1 ? (variants[0].option1 !== 'Default Title' ? 'Size' : 'Variant') : 'Variant';

    modal.innerHTML = `
      <div class="variant-modal-header">
        <h3>Seleccionar ${optionName}</h3>
        <button class="variant-modal-close" aria-label="Cerrar">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <line x1="18" y1="6" x2="6" y2="18"></line>
            <line x1="6" y1="6" x2="18" y2="18"></line>
          </svg>
        </button>
      </div>
      <div class="variant-modal-body">
        <div class="variant-list">
          ${variants.map(variant => {
            const variantName = variant.option1 || variant.title;
            const isAvailable = variant.available;
            return `
              <button class="variant-option ${!isAvailable ? 'variant-option-disabled' : ''}"
                      data-variant-id="${variant.id}"
                      ${!isAvailable ? 'disabled' : ''}>
                ${variantName}
                ${!isAvailable ? '<span class="variant-unavailable">Agotado</span>' : ''}
              </button>
            `;
          }).join('')}
        </div>
      </div>
      <div class="variant-modal-footer">
        <a href="${productUrl}" class="variant-view-product">Ver página del producto</a>
      </div>
    `;

    modalOverlay.appendChild(modal);
    document.body.appendChild(modalOverlay);

    // Trigger animation
    setTimeout(() => {
      modalOverlay.classList.add('active');
    }, 10);

    // Cerrar modal al hacer clic en overlay
    modalOverlay.addEventListener('click', function(e) {
      if (e.target === modalOverlay) {
        closeVariantModal(modalOverlay);
      }
    });

    // Cerrar modal al hacer clic en botón cerrar
    const closeBtn = modal.querySelector('.variant-modal-close');
    closeBtn.addEventListener('click', function() {
      closeVariantModal(modalOverlay);
    });

    // Manejar selección de variante
    const variantButtons = modal.querySelectorAll('.variant-option:not(.variant-option-disabled)');
    variantButtons.forEach(variantBtn => {
      variantBtn.addEventListener('click', function() {
        const selectedVariantId = this.getAttribute('data-variant-id');
        console.log('[Product Quick Add] Variant selected:', selectedVariantId);

        closeVariantModal(modalOverlay);
        addToCart(selectedVariantId, button, productContainer);
      });
    });
  }

  function closeVariantModal(modalOverlay) {
    modalOverlay.classList.remove('active');
    setTimeout(() => {
      modalOverlay.remove();
    }, 300);
  }

  function addToCart(variantId, button, productContainer) {
    if (isProcessing) {
      console.log('[Product Quick Add] Already processing, skipping');
      return;
    }

    // Check if variant is available
    const variantsData = button.getAttribute('data-variants');
    if (variantsData) {
      try {
        const variants = JSON.parse(variantsData);
        const selectedVariant = variants.find(v => v.id.toString() === variantId.toString());
        if (selectedVariant && !selectedVariant.available) {
          console.log('[Product Quick Add] Variant not available:', variantId);
          button.textContent = 'SOLD OUT';
          setTimeout(() => {
            button.textContent = button.getAttribute('data-original-text') || 'ADD TO CART';
          }, 2000);
          return;
        }
      } catch (e) {
        console.error('[Product Quick Add] Error parsing variants:', e);
      }
    }

    // Debounce check
    const now = Date.now();
    if (now - lastRequestTime < REQUEST_DEBOUNCE_MS) {
      console.log('[Product Quick Add] Request too soon, debouncing');
      return;
    }
    lastRequestTime = now;

    isProcessing = true;

    const productImage = productContainer.querySelector('img').src;
    const productTitle = productContainer.querySelector('img').alt;
    const originalText = button.textContent;

    console.log('[Product Quick Add] Adding to cart:', { variantId, productTitle });

    button.disabled = true;
    button.textContent = 'ADDING...';

    // Create a unique request ID to track this specific request
    const requestId = `${variantId}-${now}`;

    // Use XMLHttpRequest instead of fetch to avoid interceptors
    const xhr = new XMLHttpRequest();
    xhr.open('POST', '/cart/add.js', true);
    xhr.setRequestHeader('Content-Type', 'application/json');
    xhr.setRequestHeader('Accept', 'application/json');
    xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');

    xhr.onload = function() {
      console.log('[Product Quick Add] Response status:', xhr.status);

      if (xhr.status >= 200 && xhr.status < 300) {
        const data = JSON.parse(xhr.responseText);
        console.log('[Product Quick Add] Added to cart successfully', data);

        button.textContent = 'ADDED!';
        button.style.backgroundColor = '#28a745';
        button.style.color = 'white';
        button.style.borderColor = '#28a745';

        // Get updated cart
        const cartXhr = new XMLHttpRequest();
        cartXhr.open('GET', '/cart.js', true);
        cartXhr.setRequestHeader('Accept', 'application/json');

        cartXhr.onload = function() {
          if (cartXhr.status >= 200 && cartXhr.status < 300) {
            const cart = JSON.parse(cartXhr.responseText);
            console.log('[Product Quick Add] Cart updated', cart);

            const cartCountElement = document.querySelector('[data-cart-count]');
            if (cartCountElement) {
              cartCountElement.textContent = cart.item_count;
            }

            // Abrir carrito lateral (o toast si no está disponible)
            if (window.HeimatCartDrawer) {
              window.HeimatCartDrawer.open();
            } else {
              showToast(productTitle, productImage, cart.item_count);
            }

            // Disparar evento personalizado
            document.dispatchEvent(new CustomEvent('cart:updated'));
          }
        };

        cartXhr.send();

        setTimeout(() => {
          button.disabled = false;
          button.textContent = originalText;
          button.style.backgroundColor = '';
          button.style.color = '';
          button.style.borderColor = '';
          isProcessing = false;
        }, 2000);
      } else {
        console.error('[Product Quick Add] Error status:', xhr.status, xhr.responseText);
        button.disabled = false;
        button.textContent = 'ERROR';
        isProcessing = false;
        setTimeout(() => {
          button.textContent = originalText;
        }, 2000);
      }
    };

    xhr.onerror = function() {
      console.error('[Product Quick Add] Network error');
      button.disabled = false;
      button.textContent = 'ERROR';
      isProcessing = false;
      setTimeout(() => {
        button.textContent = originalText;
      }, 2000);
    };

    const payload = JSON.stringify({
      items: [{
        id: parseInt(variantId),
        quantity: 1
      }]
    });

    console.log('[Product Quick Add] Sending payload:', payload);
    xhr.send(payload);
  }

  function showToast(productTitle, productImage, cartItemCount) {
    const toastContainer = document.querySelector('.product-toast-container');
    if (!toastContainer) return;

    // Remove existing toasts
    const existingToasts = toastContainer.querySelectorAll('.product-toast');
    existingToasts.forEach(toast => toast.remove());

    const toast = document.createElement('div');
    toast.className = 'product-toast';

    toast.innerHTML = `
      <div class="product-toast-content">
        <img src="${productImage}" alt="${productTitle}" class="product-toast-image">
        <div class="product-toast-info">
          <p class="product-toast-text">${productTitle} se ha añadido a la bolsa</p>
          <a href="/cart" class="product-toast-cta">Ver bolsa (${cartItemCount})</a>
        </div>
        <button class="product-toast-close" aria-label="Cerrar">
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="2">
            <line x1="15" y1="5" x2="5" y2="15"></line>
            <line x1="5" y1="5" x2="15" y2="15"></line>
          </svg>
        </button>
      </div>
      <div class="product-toast-progress"></div>
    `;

    toastContainer.appendChild(toast);

    // Trigger animation
    setTimeout(() => {
      toast.classList.add('show');
    }, 10);

    // Auto close after 7.5 seconds
    const autoCloseTimeout = setTimeout(() => {
      closeToast(toast);
    }, 7500);

    // Close button
    const closeBtn = toast.querySelector('.product-toast-close');
    closeBtn.addEventListener('click', () => {
      clearTimeout(autoCloseTimeout);
      closeToast(toast);
    });
  }

  function closeToast(toast) {
    toast.classList.remove('show');
    setTimeout(() => {
      toast.remove();
    }, 300);
  }

  function createToastContainer() {
    if (document.querySelector('.product-toast-container')) return;

    const container = document.createElement('div');
    container.className = 'product-toast-container';
    document.body.appendChild(container);
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();